<section class="content">
	<h2 class="section-title">{{'menu.cookie' | translate}}</h2>
	<div class="box text-page">
	</div>
</section>